import { Box } from '@src/components/layout';
import { SwitchField } from '@src/corelib/forms/generic';

export default function TentativeField() {
  return (
    <Box sx={StyleSheet.tentative}> 
      <SwitchField
        fullWidth
        label="Tentative"
        name="acti_tentative"
        onTitle="Yes"
        offTitle="No"
      />
    </Box>
  );
}
const StyleSheet = {
  tentative: (theme) => ({
    background: theme.palette.common.white,
    paddingBottom: '10px',
    '.MuiFormLabel-root': {
      top: '0px',
    },
    '.MuiFormControlLabel-root': {
      display: 'flex',
      justifyContent: 'center',
      '.MuiFormControlLabel-label': {
        width: '20px',
      },
    },
  }),
};
